/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'cross-flow-support.back-to-all-products': 'すべてのアプリに戻る',
  'cross-flow-support.close': '閉じる',
  'cross-flow-support.product-store': 'アプリ ストア',
};
